import React, { useState } from "react";
import classNames from "classnames/bind";

// styles
import styles from "./styles.module.scss";

// assets
import AdImg from "src/assets/images/home/ad-img.png";
import ExternalIcon from "src/assets/images/home/external.svg";

const cx = classNames.bind(styles);

const AdItem = ({ data, ratio }) => {
  const [imgError, setImgError] = useState(false);

  return (
    <a
      href={data?.url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.ad__item__wrapper}
    >
      <div className={styles.head}>
        <span>AD</span>
        <span>{data?.name}</span>
      </div>
      <img
        src={!imgError ? data?.image : AdImg}
        alt="See more or Visits"
        onError={() => setImgError(true)}
        className={cx(ratio)}
      />
      <div className={styles.footer}>
        <span>See more or Visits</span>
        <img src={ExternalIcon} alt="external link" />
      </div>
    </a>
  );
};

export default AdItem;
